import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-parkeervergunning',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconParkeervergunning {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M9 18.99V15h2.28c.95 0 1.72.9 1.72 2s-.77 2-1.72 2H9ZM8 25c.55 0 1-.45 1-1v-3h2.3c2.04 0 3.7-1.79 3.7-4s-1.66-4-3.7-4H8c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1M36 9.99V26c0 2.21-1.79 4-4 4H3.98C1.78 30 0 28.22 0 26.02V9.99C0 7.78 1.79 6 3.99 6H17v3c0 .55.45 1 1 1s1-.45 1-1V6h13.01C34.21 6 36 7.79 36 9.99M27 23h-5c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1m2-5h-7c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1m0-5h-7c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1"/>
</svg>

    );
  }
}
